/*jshint esversion: 6 */
import Barba from 'barba.js/src';
const $ = require('jquery');
import {
    TweenMax,
    TimelineMax,
    Power4,
    Power2,
    Expo
} from "gsap";
import CustomEase from '../../../vendors/CustomEase';
import PubSub from 'pubsub-js';

export function detailToDetail(context, resolve, reject) {
    if(context.newContainer.getAttribute('data-id') === context.oldContainer.getAttribute('data-next-id') ) {
        //next page
        const oldContainer = context.oldContainer,
                newContainer = context.newContainer,
                nextSection = oldContainer.getElementsByClassName('next-project')[0];

        TweenMax.set($(nextSection).find('.vertical-center'), {height: window.innerHeight});
        TweenMax.staggerTo($(nextSection).find('a, .page-slogan, .next-project__scroll-more'), 0.3, {y: -100, opacity: 0, ease: Power4.easeIn}, 0.2);

        const tl = new TimelineMax();
        tl.to(nextSection, 0.4, {height: window.innerHeight, y: - (window.innerHeight - nextSection.offsetHeight), ease: Power4.easeIn, delay: 0.3 });
        tl.fromTo($(nextSection).find('.logo-container'), 0.3, {autoAlpha: 0, y: 100}, {autoAlpha: 1,  y: 0, onComplete: () => resolve() });
    }
    else {
        $(this.oldContainer).animate({ opacity: 0 }, 300);
        setTimeout(() => {
            resolve();
            PubSub.publish('scroll-top');
        }, 300);
    }
    const tabs = document.getElementById('siteHeader').getElementsByClassName('tabs')[0];
    tabs.parentNode.removeChild(tabs);
}


// WEBPACK FOOTER //
// ./app/components/scrolling/DJAX_animations/detailToDetail.js